import { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import CategoryGrid from "../../components/CategoryGrid/CategoryGrid";
import LoadingSkeleton from "../../components/LoadingSkeleton/LoadingSkeleton";
import SectionTitle from "../../components/ui/SectionTitle";
import { getCategories } from "../../services/categoryService";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCategories()
      .then(setCategories)
      .catch(() => setCategories([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="container-pad py-12">
      <Breadcrumb items={[{ label: "Categories" }]} />
      <SectionTitle eyebrow="Catalogue categories" title="Explore EV battery product categories" description="Select a category to view EV products, specifications, brands and quote-ready details." />
      {loading ? <LoadingSkeleton /> : <CategoryGrid categories={categories} />}
    </section>
  );
}
